import { render, staticRenderFns } from "./ImportProductQtyRecord.vue?vue&type=template&id=23878ea1"
import script from "./ImportProductQtyRecord.vue?vue&type=script&lang=js"
export * from "./ImportProductQtyRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports